import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
//api
import { getAllListsNotPaginated } from 'api/lists';
//constants
import { getKeyword } from 'constants';
//components
import { SelectInputCustom } from 'components/input';
import CustomInput from 'components/backoffice/customInput';
import CustomRadioButton from 'components/backoffice/customRadiobutton';

const MenuForm = ({
  newItem,
  setNewItem,
  menuItems,
  handleAddItem,
  isFormValid
}) => {
  const { t } = useTranslation(['backoffice']);
  const KeywordsChoice = getKeyword(t);
  const [lists, setLists] = useState([]);
  const [elementVisible, setElementVisible] = useState({
    url: true,
    pages_predef: false,
    lists: false
  });
  const [titleExists, setTitleExists] = useState(false);

  const getAllLists = async () => {
    const { data, status } = await getAllListsNotPaginated();
    if (status === 200 && data.length > 0) {
      const customList = data.map((list) => {
        return {
          value: list.nombre,
          id: list.id
        }
      })
      setLists([...customList]);
    } else {
      setLists([]);
    }
  };

  useEffect(() => {
    getAllLists();
  }, []);

  const handleAdd = () => {
    setElementVisible({
      url: true,
      pages_predef: false,
      lists: false
    })
    handleAddItem()
  }

  const handleTitleChange = (value) => {
    const exists = menuItems.some(item => item.text === value);
    setTitleExists(exists);
    setNewItem({ ...newItem, title: value });
  }

  return (
    <Row className="my-4">
      <Col sm={12}>
        <div className="text-light text-center mb-4">
          {t('completeFields')}
        </div>
      </Col>
      <Col sm={6} className='d-flex flex-column gap-3 py-1'>
        <CustomInput
          label={t('titulo')}
          type="text"
          placeholder={t('titulo')}
          value={newItem.title}
          onChange={(value) => handleTitleChange(value)}
        />
        {titleExists && (
          <small  className="text-danger">
            {t('titleExists')}
          </small>
        )}
        <SelectInputCustom
          label={t('typeOfMenu')}
          value={newItem.parentId || ''}
          onCheckedItem={(value) => setNewItem({ ...newItem, parentId: value })}
          placeholder={t('subjectsMenu')}
          choices={Array.isArray(menuItems) ? menuItems.filter(item =>  !item?.url?.state?.list).map((item) => ({ id: item.id, value: `${t('subMenu')}${item.text}` })) : []}
        />
      </Col>
      <Col sm={6} className='d-flex flex-column aling-items-start gap-3 border-grey p-2 px-5'>
        <div className='d-flex flex-row justify-content-between'>
          <CustomRadioButton
            label={t('url')}
            placeholder={`${t('pathToResource')}`}
            name='typeLink'
            checked={elementVisible.url}
            onChange={
              () => setElementVisible({ lists: false, pages_predef: false, url: true })
            }
            className='mt-0'
            containerClass='py-0 h-auto'
          />
          <CustomRadioButton
            label={t('predefinedPages')}
            name='typeLink'
            checked={elementVisible.pages_predef}
            onChange={() => setElementVisible({ url: false, lists: false, pages_predef: true })}
            className='mt-0'
            containerClass='py-0 h-auto'
          />
          <CustomRadioButton
            label={t('lista')}
            name='typeLink'
            checked={elementVisible.lists}
            onChange={() => setElementVisible({ url: false, pages_predef: false, lists: true })}
            className='mt-0'
            containerClass='py-0 h-auto'
          />
        </div>
        {elementVisible.url && <Col sm={12}>
          <CustomInput
            label={t('url')}
            placeholder={`${t('pathToResource')}`}
            type="text"
            value={newItem.url}
            onChange={(value) => setNewItem({ ...newItem, url: value, keyword: '', list: '' })}
          />
        </Col>}
        {elementVisible.pages_predef && <Col sm={12}>
          <SelectInputCustom
            label={t('predefinedPages')}
            value={newItem.keyword || ''}
            onCheckedItem={(value) => setNewItem({ ...newItem, keyword: value, url: '', list: '' })}
            placeholder={t('select')}
            choices={KeywordsChoice}
          />
        </Col>}
        {elementVisible.lists && <Col sm={12}>
          <SelectInputCustom
            label={t('listas')}
            value={newItem.list.id || ''}
            onCheckedItem={
              (value) => setNewItem({
                ...newItem, url: '',
                keyword: '',
                list: { id: value, name: lists.find(list => list.id === parseInt(value)).value }
              })}
            placeholder={t('select')}
            choices={lists}
          />
        </Col>}
      </Col>
      <Col sm={12} className="d-flex flex-column justify-content-end mt-3">
        <Button
          color="primary"
          type="submit"
          className="btn-intra bg-primary-color btn btn-primary mt-auto ms-auto"
          onClick={handleAdd}
          disabled={!isFormValid()}
        >
          {t('add')}
        </Button>
      </Col>
    </Row>
  );
};

MenuForm.propTypes = {
  newItem: PropTypes.object,
  setNewItem: PropTypes.func,
  menuItems: PropTypes.array,
  handleAddItem: PropTypes.func,
  isFormValid: PropTypes.func
};

export default MenuForm;
